/*
    Created by Phat Hoang Pham
    phat@launchdeck.org
*/

import React, { PureComponent } from 'react';
import {
    View,
    Text,
    Image
} from 'react-native-web';
import PropTypes from 'prop-types';
import moment from 'moment';

import GLOBAL from '../configs/config_global';

export default class DetailTimeSection extends PureComponent {
    // region Props
    static propTypes = {
        eventData: PropTypes.object
    };

    static defaultProps = {
        eventData: {}
    };
    // endregion

    // region MAIN RENDER FUNCTION
    render() {
        const { eventData } = this.props;

        let isSameDay = eventData.timeObj ? eventData.timeObj.isSameDay : false,
            isOnGoing = (eventData.timeObj.startTime <= moment().unix()) && (eventData.timeObj.endTime >= moment().unix()),
            isPast = eventData.timeObj.endTime < moment().unix();

        return(
            <View style={[{ alignSelf: 'stretch', flexDirection: 'row', alignItems: 'flex-start', paddingHorizontal: 24 }].concat(this.props.style)}>
                {/* Icon */}
                <Image
                    source={require('../images/iconLineDate.png')}
                    style={{ width: 24, height: 24, tintColor: GLOBAL.COLOR.BASIC.BLACK_TWO }}
                />

                {/* Time */}
                <View style={{ flex: 1, marginLeft: 16 }}>
                    {/* Time Detail */}
                    <View style={{ alignSelf: 'stretch' }}>
                        {
                            isSameDay ?
                                <View style={{ alignSelf: 'stretch' }}>
                                    <Text style={{ fontSize: 18, color: 'black', fontWeight: '500' }}>
                                        {moment.unix(eventData.timeObj.startTime).format('dddd, MMM D, YYYY')}
                                    </Text>

                                    <Text style={{ fontSize: 16, color: GLOBAL.COLOR.TEXT_LIGHT_GRAY, marginTop: 8 }}>
                                        {
                                            moment.unix(eventData.timeObj.startTime).format('h:mm A')
                                            + ' - '
                                            + moment.unix(eventData.timeObj.endTime).format('h:mm A')
                                        }
                                    </Text>
                                </View>
                                :
                                <View style={{ alignSelf: 'stretch', flexDirection: 'row', alignItems: 'center' }}>
                                    {/* Start Time */}
                                    <View>
                                        <Text style={{ fontSize: 16, color: 'black', fontWeight: '500' }}>
                                            {moment.unix(eventData.timeObj.startTime).format('ddd, MMM D, YYYY')}
                                        </Text>

                                        <Text style={{ fontSize: 14, color: GLOBAL.COLOR.TEXT_LIGHT_GRAY, marginTop: 4 }}>
                                            {moment.unix(eventData.timeObj.startTime).format('h:mm A')}
                                        </Text>
                                    </View>

                                    <View style={{ alignItems: 'center', justifyContent: 'center', marginHorizontal: 16 }}>
                                        <Image
                                            source={require('../images/iconArrowRight.png')}
                                            style={{ width: 16, height: 16, tintColor: GLOBAL.COLOR.TEXT_GRAY }}
                                        />
                                    </View>

                                    {/* End Time */}
                                    <View>
                                        <Text style={{ fontSize: 16, color: 'black', fontWeight: '500' }}>
                                            {moment.unix(eventData.timeObj.endTime).format('ddd, MMM D, YYYY')}
                                        </Text>

                                        <Text style={{ fontSize: 16, color: GLOBAL.COLOR.TEXT_LIGHT_GRAY, marginTop: 4 }}>
                                            {moment.unix(eventData.timeObj.endTime).format('h:mm A')}
                                        </Text>
                                    </View>
                                </View>
                        }
                    </View>

                    {/* Relativity */}
                    <Text style={{ fontSize: 16, color: isPast ? GLOBAL.COLOR.BASIC.NEUTRAL_GREY : GLOBAL.COLOR.MAIN, fontWeight: '500', marginTop: 8 }}>
                        {
                            isOnGoing ?
                                'ongoing event'
                                :
                                `${isPast ? 'ended ' : ''}${moment.unix(eventData.timeObj[isPast ? 'endTime' : 'startTime']).fromNow()}`
                        }
                    </Text>
                </View>
            </View>
        );
    }
    // endregion
}
